import apiService from './apiService.js';

const resource = '/locations';

export default {
    getLocations(currentPage, itemsPerPage, searchQuery) {
        return apiService.get(`${resource}`, {
            params: {
                page: currentPage,
                pageSize: itemsPerPage,
                search: searchQuery
            },
        });
    },
    getLocation(locationId) {
        return apiService.get(`${resource}/${locationId}`);
    },
    storeLocation(location) {
        return apiService.post(`${resource}`,
            {
                name: location.name,
                parent_location_id: location.parentLocation.id,
                timezone_id: location.timezoneId,
                location_type: location.locationType
            });
    },
    updateLocation(locationId, location) {
        return apiService.put(`${resource}/${locationId}`,
            {
                name: location.name,
                parent_location_id: location.parentLocation.id,
                timezone_id: location.timezoneId,
                location_type: location.locationType
            });
    },
    getTimezones() {
        return apiService.get('/list_items/timezones');
    },
    getFocusLocations() {
        return apiService.get('/locations/focus');
    },
    getLocationTypeOptions() {
        return apiService.get('/locations/types');
    },
    generateQrForRegistration() {
        return apiService.get('/locations/qr',
            {
                responseType: 'arraybuffer'
            });
    }
};
